import * as React from 'react'
import styled from 'styled-components'
import { Link } from 'gatsby'

const Circle = styled.figure`
  margin: 0;
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background-color: #659fa2;
  display: flex;
  justify-content: center;
  align-items: center;
`

export const SquareButton = styled.button`
  width: 40px;
  height: 40px;
  background-color: #659fa2;
  border: none;
  border-radius: 3px;
  color: #fff;
  cursor: pointer;
  margin-left: 8px;
`

const Title = styled.h1`
  color: #659fa2;
  font-size: 40px;
  font-weight: 400;
  line-height: 40px;
  margin: 0;
  &:not(:first-child) {
    margin-left: 8px;
  }
`

export const SubTitle = styled.h2`
  color: #90bca4;
  font-size: 20px;
  margin: 0;
  max-height: 40px;
  text-align: right;
`

export const TitleLink = styled(Link)`
  &,
  &:visited,
  &:link  {
    color: #659fa2;
  }
`

const TitleElements = styled.div`
  display: flex;
  justify-content: flex-start;
`

const Wrapper = styled.header`
  padding: 48px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: self-end;
`

interface PageHeaderProps {
  title: string
  icon?: React.ComponentType<any>
}

export const PageHeader: React.FC<PageHeaderProps> = ({
  children,
  title,
  icon: Icon
}) => {
  return (
    <Wrapper>
      <TitleElements>
        <Circle
          {...{ children: Icon && <Icon color="rgba(255,255,255,1)" /> }}
        />
        <Title>{title}</Title>
      </TitleElements>
      {children}
    </Wrapper>
  )
}
